import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import aboutus_small from "../../../images/aboutus_small.jpg";
import aboutus from "../../../images/aboutus.jpg";
import style from "./AboutUs.module.css";

export default function AboutUs() {
  const [t] = useTranslation("global");

  return (
    <Box
      id="section--about-us"
      sx={{
        backgroundColor: "var(--color-background)",
      }}
    >
      <Grid
        className="section_hidden section"
        container
        spacing={{ sm: 2, md: 4 }}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={6} sx={{ padding: { xs: "2rem", sm: 0 } }}>
          <img
            className={`${style.worker_img} lazy_img`}
            src={aboutus_small}
            data-src={aboutus}
            alt="Vineyard worker"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h2"
            component="h2"
            gutterBottom
            sx={{
              padding: "0 3.5rem",
              color: "var(--color-blue)",
              fontFamily: "var(--font-title)",
            }}
          >
            {t("component.aboutUs")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              padding: "0 3.5rem 5rem",
              lineHeight: 1.7,
              color: "var(--color-text-light)",
              fontFamily: "var(--font-text)",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "1.8rem",
                  md: "2rem",
                },
                fontFamily: "var(--font-text)"
              }}
            >
              {t("component.aboutUsText")}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
